import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);
    const accessToken = localStorage.getItem('accessToken') || '';
    const callCenter = localStorage.getItem('callCenter') === 'true';
    const customToken = localStorage.getItem('customToken') || '';
    const xConsumerUsername = activatedRoute.snapshot.firstChild?.paramMap.get('tenant') || '';

    if (!accessToken && !callCenter) {
        request = request.clone({ headers: request.headers.set('X-Consumer-Username', xConsumerUsername) });
        if (!request.headers.get('x-no-authorization')) {
            request = request.clone({ headers: request.headers.set('Authorization', `${customToken}`) });
        }
    }
    if (accessToken && !request.headers.get('x-no-authorization')) {
        if (!request.url.includes('/createLut')) {
            request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${accessToken}`) });
        }
    }

    if (request.headers.has('x-no-authorization')) {
        request = request.clone({ headers: request.headers.delete('x-no-authorization') });
    }

    return next(request).pipe(
        tap({
            error: ({ status, ...err }) => {
                const tenantKey = localStorage.getItem('tenantKey') || '';
                // NEOIQ-2427: accounts:transferToAgent uses 401 as an in-flow passcode-rejection
                // signal, not a real session expiry — confirmed by the backend team: a wrong
                // passcode comes back as a plain 401 with no otp_id (the old otp_id-challenge body
                // was for a different, now-unused retry mechanism — see enter-passcode.component.ts's
                // own "401 with no recognized detail = wrong passcode" handling). Treating every 401
                // as "log the user out" force-navigated to login and wiped localStorage mid-flow,
                // leaving the still-open SidePanelService dialog stranded on top of the login
                // screen. Only redirect for 401s that are actually about the token/session.
                const isTransferToAgentCall = request.url.includes('transferToAgent');
                if (status === 401 && !err.error?.otp_id && !isTransferToAgentCall) {
                    router.navigateByUrl(`auth/${tenantKey}/login`);
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('selectedUser');
                    localStorage.removeItem('customToken');
                    localStorage.removeItem('tenantKey');
                    localStorage.removeItem('callCenter');
                    localStorage.removeItem('isSubAgent');
                    localStorage.removeItem('parentUserId');
                    localStorage.removeItem('masterAccount');
                    localStorage.removeItem('masterAccountId');
                } else if (status === 403 && err.error.detail === 'Current session is expired, please login again.') {
                    router.navigateByUrl(`auth/${tenantKey}/login`);
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('selectedUser');
                    localStorage.removeItem('customToken');
                    localStorage.removeItem('tenantKey');
                    localStorage.removeItem('callCenter');
                    localStorage.removeItem('permissions');
                    localStorage.removeItem('userInfo');
                    localStorage.removeItem('isSubAgent');
                    localStorage.removeItem('parentUserId');
                    localStorage.removeItem('masterAccount');
                    localStorage.removeItem('masterAccountId');
                    localStorage.clear();
                }
            },
        }),
    );
};
